<template>
  <header>
    <archive-notice />
    <div id="button-links">
      <div class="social-links">
        <social-buttons :links="headerText.links" />
      </div>
      <div class="switchers">
        <language-switcher />
        <edition-switcher />
      </div>
    </div>
    <div id="rectangle" :style="{ transform: `translateY(${scrollY * 0.4}px)` }">
      <div id="banner" class="drop-shadow">
        <p class="date-row">
          <span class="date-place drop-shadow"><i class="pi pi-calendar"></i>{{ headerText.date }}</span>
          <span class="date-place drop-shadow"><i class="pi pi-building"></i>{{ headerText.place }}</span>
        </p>
        <p class="drop-shadow">
          <img :src="headerText.logo" alt="CYB3R Days" id="logo" />
        </p>
        <div id="subtitle">
          <div>
            <p class="sub-title glitch-text" :data-text="headerText.subtitle">
              {{ headerText.subtitle }}
            </p>
          </div>
          <div>
            <p class="sub-sub-title glitch-text" :data-text="$t('header.tagline')">
              {{ $t('header.tagline') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script scoped>
import SocialButtons from "./SocialButtons.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import EditionSwitcher from "./EditionSwitcher.vue";
import ArchiveNotice from "./ArchiveNotice.vue";
export default {
  name: "TheHeader",
  props: {
    headerText: Object,
  },
  data() {
    return {
      scrollY: 0,
    };
  },
  components: {
    SocialButtons,
    LanguageSwitcher,
    EditionSwitcher,
    ArchiveNotice,
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    },
  },
};
</script>

<style scoped>
* {
  color: white;
}

#button-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px 35px;
  padding: 45px 16px 0;
}

.social-links,
.switchers {
  display: flex;
  align-items: center;
}

.switchers {
  gap: 20px;
}

/* Poslední ikona nemá mít mezeru vpravo, jinak řádek uhýbá doleva */
.social-links :deep(a:last-child span) {
  margin-right: 0;
}

.switchers .edition-switcher {
  margin-left: 0;
}

#subtitle {
  font-size: 30px;
  font-weight: 300;
  margin: 0;
  letter-spacing: 0.09em;
  margin-bottom: 10px;
  line-height: 1.1;
}

.drop-shadow {
  -webkit-filter: drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.1));
}

#banner {
  text-align: center;
  padding: 75px 16px 0;
}

#logo {
  max-width: 100%;
  height: auto;
}

.sub-title {
  text-shadow: 0 0 10px #ff006f;
  font-weight: bold;
}

.sub-sub-title {
  margin-top: 30px;
}

.date-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 25%;
}

.date-place {
  letter-spacing: 0.2em;
  font-weight: 700;
  font-size: 19px;
  line-height: 1.7;
}

.date-place i {
  margin-right: 10px;
}

#rectangle {
  margin-top: 20vh;
  width: 100%;
  height: 45vh;
  border-radius: 100%;
}

i {
  color: rgb(255, 168, 0);
}

.buy-ticket-container {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 10;
}

.buy-ticket-btn {
  background: linear-gradient(135deg,
      rgb(255, 168, 0) 0%,
      rgb(230, 150, 0) 100%);
  color: white;
  border: none;
  padding: 15px 40px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(255, 168, 0, 0.3), 0 0 30px rgba(255, 168, 0, 0.5);
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  animation: glow 2s ease-in-out infinite alternate;
}

.buy-ticket-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 168, 0, 0.4), 0 0 40px rgba(255, 168, 0, 0.7);
  background: linear-gradient(135deg,
      rgb(255, 178, 20) 0%,
      rgb(240, 160, 10) 100%);
}

.buy-ticket-btn:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(255, 168, 0, 0.3);
}

@media only screen and (max-width: 900px) {
  #button-links {
    flex-direction: column;
    gap: 14px;
    padding-top: 24px;
  }

  #subtitle {
    font-size: 18px;
  }

  .date-place {
    font-size: 15px;
  }

  .date-row {
    flex-direction: column;
    align-items: center;
  }

  #logo {
    width: 100%;
  }

  #banner {
    padding-top: 40px;
    filter: none !important;
  }

  #rectangle {
    margin-top: 12vh;
    height: auto;
  }

  .sub-sub-title {
    margin-top: 16px;
  }

  .buy-ticket-container {
    bottom: 10px;
  }
}

@media only screen and (max-width: 480px) {
  #subtitle {
    font-size: 14px;
    letter-spacing: 0.04em;
  }

  .date-place {
    font-size: 14px;
    letter-spacing: 0.12em;
  }
}

@keyframes glow {
  from {
    box-shadow: 0 4px 15px rgba(255, 168, 0, 0.3),
      0 0 30px rgba(255, 168, 0, 0.5);
  }

  to {
    box-shadow: 0 4px 15px rgba(255, 168, 0, 0.3),
      0 0 40px rgba(255, 168, 0, 0.8);
  }
}
</style>
